import { Avatar, Box, IconButton, Text, useMediaQuery } from '@maas-components/core'
import { PersonOutline } from '@maas-components/icons'
import { Theme, useTheme } from '@maas-components/styles'
import { bindTrigger } from 'material-ui-popup-state'
import { PopupState } from 'material-ui-popup-state/hooks'
import { useTranslation } from 'react-i18next'
import useStyles from '../style'

interface ProfileButtonProps {
  enableUserInfo?: boolean
  name: string
  popupState: PopupState
}

export default function ProfileButton({ enableUserInfo, name, popupState }: ProfileButtonProps) {
  const classes = useStyles()
  const theme: Theme = useTheme()
  const { t } = useTranslation()
  const isMobile = useMediaQuery((themeMQ: Theme) => themeMQ.breakpoints.down('sm'))

  return (
    <IconButton
      data-testid="profile-button-test-id"
      size="small"
      color="inherit"
      className={classes.profileButton}
      {...bindTrigger(popupState)}
    >
      {enableUserInfo && !isMobile && (
        <Box display="flex" flexDirection="column" alignItems="flex-start" mx={2}>
          <Text component="span" fontWeight="bold" fontSize="small" className={classes.userInfo}>
            {`${t('app.profile.hello')}, ${name}`}
          </Text>
        </Box>
      )}
      <Avatar alt={name} className={classes.avatar}>
        <PersonOutline
          color={theme.shellMode === 'light' ? 'inherit' : 'secondary'}
          fontSize="large"
        />
      </Avatar>
    </IconButton>
  )
}
